import { TipoPA } from "src/app/sitfis/components/debito-sief/model/tipo-pa";
import { DebitoSief } from "src/app/sitfis/model/debito-sief";

export const DEBITO_SIEF_COBRANCA: DebitoSief[] = [
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002025500000015158041",
    "codigoTributo": "01",
    "nomeTributo": "IRRF",
    "codigoReceita": "0561",
    "dataVencimento": "2025-02-20",
    "valorOriginal": 300.0,
    "valorSaldoDevedor": 300.0,
    "unidadeMonetaria": "REAL",
    "tipoPA": TipoPA.MENSAL,  // Não entendi, o valor que vem da API é 5
    "dataPaExercicio": "20250100",
    "situacaoDebito": "DEVEDOR",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "07",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": "",
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": null
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002025500000015158045",
    "codigoTributo": "01",
    "nomeTributo": "IRRF",
    "codigoReceita": "0588",
    "dataVencimento": "2025-02-20",
    "valorOriginal": 350.0,
    "valorSaldoDevedor": 350.0,
    "unidadeMonetaria": "REAL",
    "tipoPA": TipoPA.MENSAL,
    "dataPaExercicio": "20250100",
    "situacaoDebito": "DEVEDOR",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "06",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": "",
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": null
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00000012024500000003095536",
    "codigoTributo": "44",
    "nomeTributo": "MAED - DCTF",
    "codigoReceita": "1345",
    "dataVencimento": "2024-08-09",
    "valorOriginal": 200.0,
    "valorSaldoDevedor": 200.0,
    "unidadeMonetaria": "REAL",
    "tipoPA": TipoPA.DIARIO,  // Não entendi, o valor que vem da API é 1
    "dataPaExercicio": "20240322",
    "situacaoDebito": "DEVEDOR",
    "numeroAutoInfracao": "081040020244091659",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "000000000011140314010500",
    "codigoExtensaoReceita": "01",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "N",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": "",
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": null
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00000012024500000003173683",
    "codigoTributo": "44",
    "nomeTributo": "MAED - DCTFWEB",
    "codigoReceita": "5440",
    "dataVencimento": "2024-09-02",
    "valorOriginal": 80.2,
    "valorSaldoDevedor": 80.2,
    "unidadeMonetaria": "REAL",
    "tipoPA": TipoPA.DIARIO,
    "dataPaExercicio": "20240416",
    "situacaoDebito": "DEVEDOR",
    "numeroAutoInfracao": "081040020244093212",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "000000000000022000003458",
    "codigoExtensaoReceita": "01",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "N",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": "",
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": null
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00000012024500000003467294",
    "codigoTributo": "44",
    "nomeTributo": "MAED - DCTFWEB",
    "codigoReceita": "5440",
    "dataVencimento": "2024-11-05",
    "valorOriginal": 250.0,
    "valorSaldoDevedor": 250.0,
    "unidadeMonetaria": "REAL",
    "tipoPA": TipoPA.DIARIO,
    "dataPaExercicio": "20240917",
    "situacaoDebito": "DEVEDOR",
    "numeroAutoInfracao": "081040020244098448",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "000000000000022000003732",
    "codigoExtensaoReceita": "01",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "N",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": "",
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": null
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002025500000015158057",
    "codigoTributo": "82",
    "nomeTributo": "CONTRIB-PREV",
    "codigoReceita": "2985",
    "dataVencimento": "2025-02-20",
    "valorOriginal": 2100.0,
    "valorSaldoDevedor": 2100.0,
    "unidadeMonetaria": "REAL",
    "tipoPA": TipoPA.MENSAL,
    "dataPaExercicio": "20250100",
    "situacaoDebito": "DEVEDOR",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "01",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": "",
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": null
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002024100003872319765",
    "codigoTributo": "83",
    "nomeTributo": "CP-SEGUR.",
    "codigoReceita": "1082",
    "dataVencimento": "2024-04-19",
    "valorOriginal": 4034.85,
    "valorSaldoDevedor": 4034.85,
    "unidadeMonetaria": "REAL",
    "tipoPA": TipoPA.MENSAL,
    "dataPaExercicio": "20240300",
    "situacaoDebito": "DEVEDOR",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "01",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": "",
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": null
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002024500000014943666",
    "codigoTributo": "83",
    "nomeTributo": "CP-SEGUR.",
    "codigoReceita": "1082",
    "dataVencimento": "2024-09-20",
    "valorOriginal": 6.0,
    "valorSaldoDevedor": 6.0,
    "unidadeMonetaria": "REAL",
    "tipoPA": TipoPA.MENSAL,
    "dataPaExercicio": "20240800",
    "situacaoDebito": "DEVEDOR",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "51",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": "",
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": null
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002024500000014943664",
    "codigoTributo": "83",
    "nomeTributo": "CP-SEGUR.",
    "codigoReceita": "1082",
    "dataVencimento": "2024-10-18",
    "valorOriginal": 5.0,
    "valorSaldoDevedor": 5.0,
    "unidadeMonetaria": "REAL",
    "tipoPA": TipoPA.MENSAL,
    "dataPaExercicio": "20240900",
    "situacaoDebito": "DEVEDOR",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "51",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": "",
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": null
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002024500000014943665",
    "codigoTributo": "83",
    "nomeTributo": "CP-SEGUR.",
    "codigoReceita": "1082",
    "dataVencimento": "2024-11-19",
    "valorOriginal": 6.0,
    "valorSaldoDevedor": 6.0,
    "unidadeMonetaria": "REAL",
    "tipoPA": TipoPA.MENSAL,
    "dataPaExercicio": "20241000",
    "situacaoDebito": "DEVEDOR",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "51",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": "",
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": null
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002025500000015158043",
    "codigoTributo": "84",
    "nomeTributo": "CP-PATRONAL",
    "codigoReceita": "1138",
    "dataVencimento": "2025-02-20",
    "valorOriginal": 5000.0,
    "valorSaldoDevedor": 5000.0,
    "unidadeMonetaria": "REAL",
    "tipoPA": TipoPA.MENSAL,
    "dataPaExercicio": "20250100",
    "situacaoDebito": "DEVEDOR",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "01",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": "",
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": null
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002025500000015158053",
    "codigoTributo": "84",
    "nomeTributo": "CP-PATRONAL",
    "codigoReceita": "1138",
    "dataVencimento": "2025-02-20",
    "valorOriginal": 500.0,
    "valorSaldoDevedor": 500.0,
    "unidadeMonetaria": "REAL",
    "tipoPA": TipoPA.MENSAL,
    "dataPaExercicio": "20250100",
    "situacaoDebito": "DEVEDOR",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "01",
    "niPrestador": "",
    "numeroCno": "000000028151",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": "",
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": null
  }
];

export const DEBITO_SIEF_EXIGIBILIDADE = [
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002024500000015115790",
    "codigoTributo": "05",
    "nomeTributo": "COFINS",
    "codigoReceita": "6404",
    "dataVencimento": "2025-02-25",
    "valorOriginal": 7.7,
    "valorSaldoDevedor": 7.7,
    "unidadeMonetaria": "REAL",
    "tipoPA": 5,
    "dataPaExercicio": "20250100",
    "situacaoDebito": "A ANALISAR-A VENCER",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "01",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": null,
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": "3"
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002024500000015115789",
    "codigoTributo": "08",
    "nomeTributo": "IRPJ",
    "codigoReceita": "6388",
    "dataVencimento": "2025-02-28",
    "valorOriginal": 17.7,
    "valorSaldoDevedor": 17.7,
    "unidadeMonetaria": "REAL",
    "tipoPA": 5,
    "dataPaExercicio": "20250100",
    "situacaoDebito": "A ANALISAR-A VENCER",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "01",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": null,
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": "3"
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002024500000015115791",
    "codigoTributo": "08",
    "nomeTributo": "IRPJ",
    "codigoReceita": "6388",
    "dataVencimento": "2025-03-31",
    "valorOriginal": 17.7,
    "valorSaldoDevedor": 17.7,
    "unidadeMonetaria": "REAL",
    "tipoPA": 5,
    "dataPaExercicio": "20250200",
    "situacaoDebito": "A ANALISAR-A VENCER",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "01",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": null,
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": "3"
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002025500000015359296",
    "codigoTributo": "08",
    "nomeTributo": "IRPJ",
    "codigoReceita": "6388",
    "dataVencimento": "2025-04-30",
    "valorOriginal": 27.7,
    "valorSaldoDevedor": 17.7,
    "unidadeMonetaria": "REAL",
    "tipoPA": 5,
    "dataPaExercicio": "20250300",
    "situacaoDebito": "A ANALISAR-A VENCER",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "01",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": null,
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": "3"
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002025500000015359294",
    "codigoTributo": "83",
    "nomeTributo": "CP-SEGUR.",
    "codigoReceita": "1082",
    "dataVencimento": "2025-04-17",
    "valorOriginal": 9.99,
    "valorSaldoDevedor": 9.99,
    "unidadeMonetaria": "REAL",
    "tipoPA": 5,
    "dataPaExercicio": "20250300",
    "situacaoDebito": "A ANALISAR-A VENCER",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "07",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": null,
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": "3"
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002025500000015359293",
    "codigoTributo": "83",
    "nomeTributo": "CP-SEGUR.",
    "codigoReceita": "1099",
    "dataVencimento": "2025-04-17",
    "valorOriginal": 91.99,
    "valorSaldoDevedor": 91.99,
    "unidadeMonetaria": "REAL",
    "tipoPA": 5,
    "dataPaExercicio": "20250300",
    "situacaoDebito": "A ANALISAR-A VENCER",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "02",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": null,
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": "3"
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002025500000015359298",
    "codigoTributo": "84",
    "nomeTributo": "CP-PATRONAL",
    "codigoReceita": "1138",
    "dataVencimento": "2025-04-17",
    "valorOriginal": 79.99,
    "valorSaldoDevedor": 79.99,
    "unidadeMonetaria": "REAL",
    "tipoPA": 5,
    "dataPaExercicio": "20250300",
    "situacaoDebito": "A ANALISAR-A VENCER",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "07",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": null,
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": "3"
  },
  {
    "ni": "03763656000154",
    "numeroDebito": "00001002025500000015359297",
    "codigoTributo": "85",
    "nomeTributo": "CP-TERCEIROS",
    "codigoReceita": "1221",
    "dataVencimento": "2025-04-17",
    "valorOriginal": 99.99,
    "valorSaldoDevedor": 99.99,
    "unidadeMonetaria": "REAL",
    "tipoPA": 5,
    "dataPaExercicio": "20250300",
    "situacaoDebito": "A ANALISAR-A VENCER",
    "numeroAutoInfracao": "",
    "numeroPerdcomp": "",
    "numeroNotificacaoDoi": "",
    "codigoExtensaoReceita": "01",
    "niPrestador": "",
    "numeroCno": "",
    "inDctfweb": "S",
    "inOrdemDarf": "1",
    "codigoTipoSolidariedade": "",
    "tipoSolidariedade": "",
    "codigoSituacaoVinculo": "",
    "situacaoVinculo": "",
    "tipoDevedorPrincipal": "",
    "niDevedorPrincipal": "",
    "dataCiencia": null,
    "numeroReferenciaDarf": null,
    "indExibeDarf": true,
    "indTipoDebitoProcesso": 0,
    "ehSolidario": false,
    "inTpExigibilidade": "3"
  }
];
